import { render, staticRenderFns } from "./CheckUser.vue?vue&type=template&id=3970f4ed"
import script from "./CheckUser.vue?vue&type=script&lang=js"
export * from "./CheckUser.vue?vue&type=script&lang=js"
import style0 from "./CheckUser.vue?vue&type=style&index=0&id=3970f4ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports